import React, { FC, useState, useEffect } from "react";
import { Button } from "@mui/material";
import { FiCheckSquare, FiRefreshCw, FiSquare } from "react-icons/fi";

import flex from "../styles/flex";

interface IAutoRefreshProps {
    default?: boolean;
    showUI?: boolean;
    onRefresh: () => void;
    durationSeconds: number;
}

const AutoRefresh: FC<IAutoRefreshProps> = (props) => {
    const [lastRefresh, setLastRefresh] = useState(new Date().toLocaleTimeString());
    const [refresh, setRefresh] = useState(props.default);
    const [cancel, setCancel] = useState<NodeJS.Timeout | null>(null);

    const refreshNow = () => {
        if (cancel) {
            clearTimeout(cancel);
        }

        const cancelTimeout = setTimeout(() => {
            props.onRefresh();

            setLastRefresh(new Date().toLocaleTimeString())

            if (refresh) {
                refreshNow();
            }
        }, props.durationSeconds * 1000)

        setCancel(cancelTimeout)
    }

    useEffect(() => {
        if (refresh) {
            refreshNow()
        }

        return () => {
            if (cancel) {
                clearTimeout(cancel)
            }
        }
    }, [])

    if (!props.showUI) {
        return null;
    }

    return (
        <div style={flex.flexRows}>
            <div style={flex.flexAuto}>
                <Button
                    style={{ marginRight: 10 }}
                    variant="contained"
                    onClick={() => {
                        if (cancel) {
                            clearTimeout(cancel);
                        }
                        props.onRefresh();
                        setLastRefresh(new Date().toLocaleTimeString());
                    }}>
                    <FiRefreshCw style={{ marginRight: 10 }} />
                    <div>
                        Refreshed: {lastRefresh}
                    </div>
                </Button>
            </div>
            <div style={flex.flexAuto}>
                <Button
                    title={`Auto refresh every ${props.durationSeconds} seconds`}
                    style={{ marginRight: 10 }}
                    variant="contained"
                    color={refresh ? "secondary" : "primary"}
                    onClick={() => {
                        if(cancel){
                            clearTimeout(cancel);
                        }
                        setRefresh(!refresh)
                        refreshNow();
                    }}
                >
                    {
                        refresh
                            ? <FiCheckSquare style={{ marginRight: 10 }} />
                            : <FiSquare style={{ marginRight: 10 }} />
                    }
                    <div>Auto Refresh</div>
                </Button>
            </div>
        </div>
    );
}
  
export default AutoRefresh;